import { render, staticRenderFns } from "./CosignerAlert.vue?vue&type=template&id=9d6ce710&scoped=true&"
import script from "./CosignerAlert.vue?vue&type=script&lang=js&"
export * from "./CosignerAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d6ce710",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
